import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Label, Col, Form, Input, FormGroup, FormFeedback } from 'reactstrap';
import { AvForm, AvField, AvGroup } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import { loadRestaurantProducts, dispatchErrorMessage } from '../../../actions/index';
import { FREE_PRODUCT, COMBO_DEAL, PRICE_DISCOUNT } from '../../../utils/Constants';
import { getCurrencySymbol } from '../../../utils/CommonUtils';

const PRICE_DISCOUNT_INITIAL = {
    "discountValue": '',
    "valueInPercentage": false
};

const FREE_PRODUCT_INITIAL = {
    "productId": '',
    "productName": '',
    "quantity": ''
};

const COMBO_DEAL_INITIAL = {
    "discountValue": '',
    "valueInPercentage": false,
    "buyProductsCount": '',
    "freeProductsCount": '',
    valueIsDiscount: true
};

class PromotionTypeScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            promotionId: null,
            discountType: null,
            priceDiscount: null,
            freeProduct: null,
            comboDeal: null,
            // TODO dont use it in the state use it in the props only
            products: null,
            matchedFromSearch: [],
            noProductFound: false,
            invalidForm: false,
            currentTemplate: null,
            description: null,
            stateAlreadyCopiedFromProps: false
        };

        this.changeFieldState = this.changeFieldState.bind(this);
        this.changeCheckBoxState = this.changeCheckBoxState.bind(this);
        this.changeDiscountType = this.changeDiscountType.bind(this);
        this.changeDescriptionState = this.changeDescriptionState.bind(this);
    }

    appendNamePropToProductObject() {
        this.state.products.map((product) => {
            if (product.id === this.props.freeProduct.productId) {
                let loadedProductWithNameProp = { ...this.state.freeProduct, productName: product.name };
                this.setState({ ...this.state, freeProduct: loadedProductWithNameProp });
            }
        });
    }

    copyStateFromProps() {
        if (this.props.promotionId !== undefined && this.props.promotionId !== null &&
            (!this.state.stateAlreadyCopiedFromProps || this.props.promotionId !== this.state.promotionId)) {
            // If free product comes from props load the products
            if (this.props.discountType === FREE_PRODUCT) {
                this.props.loadRestaurantProducts(this.props.restaurantId, null, () => {
                    this.setState({ ...this.state, products: this.props.products }, () => {

                        if (!this.state.products.length) {
                            this.props.dispatchErrorMessage(i18n.t('screens:promotionTypeScreen.noMenuConfiguredMsg'));
                        }

                        this.appendNamePropToProductObject();
                    });
                });
            }
            // If combo Deal hide the condition tab in the parent
            if (this.props.discountType === COMBO_DEAL) {
                this.props.hideConditionTab();
            }

            this.setState({
                promotionId: this.props.promotionId,
                discountType: this.props.discountType ? this.props.discountType : PRICE_DISCOUNT,
                priceDiscount: this.props.priceDiscount ? this.props.priceDiscount : PRICE_DISCOUNT_INITIAL,
                freeProduct: this.props.freeProduct ? this.props.freeProduct : FREE_PRODUCT_INITIAL,
                comboDeal: this.props.comboDeal ? this.props.comboDeal : COMBO_DEAL_INITIAL,
                description: this.props.description,
                stateAlreadyCopiedFromProps: true
            });
        }
    }

    componentWillUnmount() {
        // Send the updated state data to the parent component
        this.props.getPageData(this.state);
    }

    handleTabValidation() {
        const { priceDiscount, freeProduct, comboDeal, discountType, products } = this.state;
        let validFormData = true;

        if (discountType === PRICE_DISCOUNT) {
            if (!priceDiscount.discountValue) {
                this.state.invalidForm = true;
                this.props.cancelTabChangeRequest();
                validFormData = false;
                return validFormData;
            }
        }

        if (discountType === FREE_PRODUCT) {

            for (let i = 0; i < products.length; i++) {
                if ((products[i].name == freeProduct.productName) && freeProduct.quantity) {
                    validFormData = true;

                    return validFormData;

                } else {
                    validFormData = false;
                }
            }

            if (!validFormData) {
                this.state.noProductFound = false;
                this.state.invalidForm = true;
                this.state.noProductFound = true;
                this.props.cancelTabChangeRequest();

                return validFormData;
            }

            if (!freeProduct.productName || !freeProduct.quantity) {
                this.state.invalidForm = true;
                this.props.cancelTabChangeRequest();
                validFormData = false;
                return validFormData;
            }
        }

        if (discountType === COMBO_DEAL) {
            if (!comboDeal.discountValue || !comboDeal.buyProductsCount || !comboDeal.freeProductsCount) {
                this.state.invalidForm = true;
                this.props.cancelTabChangeRequest();
                validFormData = false;
                return validFormData;
            }
        }

        return validFormData;
    }

    submitForm() {
        let validFormData = this.handleTabValidation();
        // If tab data is valid go to next page or submit the form
        if (validFormData) {
            this.props.goToNextPage();
        } else { // If not tell the parent component that form is invalid
            this.props.setInvalidTabData();
        }
    }

    changeFieldState({ target }) {
        //TODO problem with updating the state
        if (this.state.priceDiscount && this.state.discountType === PRICE_DISCOUNT) {
            let updatedPriceDiscount = { ...this.state.priceDiscount };
            updatedPriceDiscount[target.name] = Number(target.value);

            this.setState({ ...this.state, priceDiscount: updatedPriceDiscount });
        } else if (this.state.freeProduct && this.state.discountType === FREE_PRODUCT) {
            let updatedFreeProduct = { ...this.state.freeProduct };
            updatedFreeProduct[target.name] = target.value;

            this.setState({ ...this.state, freeProduct: updatedFreeProduct, noProductFound: false });
        } else if (this.state.comboDeal && this.state.discountType === COMBO_DEAL) {
            let updatedComboDeal = { ...this.state.comboDeal };

            if (target.name === 'discountValue' || target.name === 'freeProductsCount' || target.name === 'buyProductsCount') {
                updatedComboDeal[target.name] = parseInt(target.value);
            } else {
                updatedComboDeal[target.name] = target.value;
            }

            this.setState({ ...this.state, comboDeal: updatedComboDeal });
        }
    }

    changeDescriptionState({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    changeCheckBoxState({ target }) {
        if (this.state.discountType === PRICE_DISCOUNT) {
            let updatedPriceDiscount = { ...this.state.priceDiscount };
            updatedPriceDiscount[target.name] = target.checked;

            this.setState({ priceDiscount: updatedPriceDiscount });

        } else if (this.state.discountType === COMBO_DEAL) {

            let updatedComboDeal = { ...this.state.comboDeal };
            updatedComboDeal[target.name] = target.checked;

            this.setState({ comboDeal: updatedComboDeal });
        }
    }

    changeDiscountType({ target }) {
        const { priceDiscount, freeProduct, comboDeal } = this.state;

        if (target.value === 'priceDiscount') {
            let initialPriceDiscount = { ...PRICE_DISCOUNT_INITIAL };

            this.setState({
                ...this.state,
                discountType: PRICE_DISCOUNT,
                invalidForm: false,
                priceDiscount: (priceDiscount !== null) ? priceDiscount : initialPriceDiscount
            });

            this.props.showConditionTab();
        } else if (target.value === 'freeProduct') {
            let initialFreeProduct = { ...FREE_PRODUCT_INITIAL };

            this.setState({
                ...this.state,
                discountType: FREE_PRODUCT,
                invalidForm: false,
                freeProduct: (freeProduct !== null) ? freeProduct : initialFreeProduct
            });
            // Load Products for restaurant
            this.props.loadRestaurantProducts(this.props.restaurantId, null, () => {
                this.setState({ ...this.state, products: this.props.products }, () => {

                    if (!this.state.products.length) {
                        this.props.dispatchErrorMessage(i18n.t('screens:promotionTypeScreen.'));
                    }
                });
            });

            this.props.showConditionTab();
        } else if (target.value === 'comboDeal') {
            let initialComboDeal = { ...COMBO_DEAL_INITIAL };

            this.setState({
                ...this.state,
                discountType: COMBO_DEAL,
                invalidForm: false,
                comboDeal: (comboDeal !== null) ? comboDeal : initialComboDeal
            });

            this.props.hideConditionTab();
        }
    }

    renderDiscountTypeRadioBtns() {
        const { radioBtnStyle, radioButtonsContainer } = styles;

        return (
            <div style={styles.promotionTimeContainer}>
                <Form inline name="promotion_time" style={radioButtonsContainer}>
                    <Input type="radio" name="promotion_time" value="priceDiscount"
                        style={radioBtnStyle}
                        checked={this.state.discountType === PRICE_DISCOUNT}
                        onChange={this.changeDiscountType}
                    />
                    <Label for="priceDiscount">{i18n.t('screens:promotionsScreen.summaryPrice')}</Label>

                    <Input type="radio" name="promotion_time" value="freeProduct"
                        style={radioBtnStyle}
                        checked={this.state.discountType === FREE_PRODUCT}
                        onChange={this.changeDiscountType}
                    />
                    <Label for="freeProduct">{i18n.t('screens:promotionsScreen.summaryProduct')}</Label>

                    <Input type="radio" name="promotion_time" value="comboDeal"
                        style={radioBtnStyle}
                        checked={this.state.discountType === COMBO_DEAL}
                        onChange={this.changeDiscountType}
                    />
                    <Label for="comboDeal">{i18n.t('screens:promotionsScreen.summaryCombo')}</Label>
                </Form>
            </div>
        );
    }

    renderDiscountTypeContent() {
        if (this.state.discountType === PRICE_DISCOUNT) {
            return (this.renderPriceDiscountFields());
        }

        if (this.state.discountType === FREE_PRODUCT) {
            return (this.renderFreeProductFields());
        }

        if (this.state.discountType === COMBO_DEAL) {
            return (this.renderComboDealFields());
        }
    }

    getValue(value) {
        return value || '';
    }

    renderPriceDiscountFields() {
        const { invalidForm, priceDiscount } = this.state;
        const { validationFieldInput, checkboxInput, labelField, smallFormContainer, discountLabelField, formFeedback } = styles;

        return (
            <div style={smallFormContainer}>
                <Form>
                    <FormGroup row>
                        <Label style={labelField}>{i18n.t('screens:promotionTypeScreen.discount')}</Label>
                        <Col sm={2}>
                            {/* add invalid atribute to the field dynamically to make it invalid on flag condition FormFeedback is activated when invalid is added to the input */}
                            <Input type="number" name="discountValue" id="discountProductId" placeholder="number"
                                invalid={invalidForm && !priceDiscount.discountValue}
                                value={this.getValue(priceDiscount.discountValue)}
                                onChange={this.changeFieldState}
                                min={0} step="0.5"
                                style={validationFieldInput}
                            />
                            <FormFeedback style={formFeedback}>{i18n.t('common:validations.errorMsg')}</FormFeedback>
                        </Col>
                        <Label style={labelField}>{(priceDiscount.valueInPercentage) ? <p>%</p> :
                            <span style={{ paddingBottom: 20 }}>{getCurrencySymbol(this.props.restaurant.currency)}</span>}
                        </Label>
                        <Label style={discountLabelField} check for="discountInPercentageId">
                            {i18n.t('screens:promotionTypeScreen.discountInPercentage')}
                            <Input name="valueInPercentage" style={checkboxInput} type="checkbox"
                                id="discountInPercentageId"
                                checked={priceDiscount ? priceDiscount.valueInPercentage : null}
                                value={priceDiscount ? priceDiscount.valueInPercentage : null}
                                onChange={this.changeCheckBoxState}
                            />
                        </Label>
                    </FormGroup>
                </Form>
            </div>
        );
    }

    renderFreeProductFields() {
        const { labelField, smallFormContainer } = styles;

        return (
            <div style={{ position: 'relative' }}>
                <AvForm style={smallFormContainer}>
                    <AvGroup row>
                        <Label style={labelField}>{i18n.t('screens:promotionTypeScreen.product')}</Label>
                        <Col sm={6}>
                            <AvField type="text" name="productName" id="productName" placeholder={i18n.t('screens:promotionTypeScreen.typeProductPlaceholder')}
                                autocomplete="off"
                                min={0}
                                value={this.state.freeProduct.productName}
                                onChange={this.changeFieldState}
                                onKeyUp={(e) => this.handleKeyUp(e)}
                                onBlur={() => this.handleAutoSearchFocusOut()}
                                invalid={(this.state.invalidForm && !this.state.freeProduct.productName) || this.state.noProductFound}
                            />
                            <FormGroup>
                                <Input type="text" style={{ height: 0, display: 'none' }}
                                    invalid={(this.state.invalidForm && !this.state.freeProduct.productName) || this.state.noProductFound}
                                />
                                <FormFeedback>{(this.state.noProductFound && this.state.freeProduct.productName !== '') ? i18n.t('screens:promotionTypeScreen.noProductFoundMsg') : i18n.t('common:validations.errorMsg')}</FormFeedback>
                            </FormGroup>
                        </Col>
                        <Label style={labelField}>{i18n.t('screens:promotionTypeScreen.quantity')}</Label>
                        <Col sm={2}>
                            <AvField type="number" name="quantity" id="discountQuantity" placeholder={i18n.t('screens:promotionTypeScreen.number')}
                                min={0}
                                onChange={this.changeFieldState}
                                onKeyPress={(e) => this.negativeIntegersValidation(e)}
                                value={this.getValue(this.state.freeProduct.quantity)}
                                invalid={this.state.invalidForm && !this.state.freeProduct.quantity}
                            />
                            <FormGroup>
                                <Input type="text" style={{ height: 0, display: 'none' }}
                                    invalid={this.state.invalidForm && !this.state.freeProduct.quantity}
                                />
                                <FormFeedback style={{ width: 150 }}>{i18n.t('common:validations.errorMsg')}</FormFeedback>
                            </FormGroup>
                        </Col>
                    </AvGroup>
                </AvForm>
                {this.state.matchedFromSearch.length ? this.renderSearchResults() : ''}
            </div>
        );
    }

    getProductName(selectedProductName, selectedProductId) {
        let updatedFreeProduct = { ...this.state.freeProduct };
        updatedFreeProduct.productName = selectedProductName;
        updatedFreeProduct.productId = selectedProductId;

        let emptyMatchedFromSearchArray = this.state.matchedFromSearch.filter((product) => null);

        this.setState({ ...this.state, freeProduct: updatedFreeProduct, matchedFromSearch: emptyMatchedFromSearchArray });
    }

    renderComboDealFields() {
        const { invalidForm, comboDeal } = this.state;
        const { labelInPercents, labelField, smallFormContainerComboDeal,
            percentStyling, timeFormatInfoMessage, infoMessagesContainer, comboErrorMessage } = styles;

        return (
            <div>
                <Form style={smallFormContainerComboDeal}>
                    <FormGroup row>
                        <Label style={labelField}>{i18n.t('screens:promotionTypeScreen.buy')}</Label>
                        <Col sm={2} style={{ marginBottom: '20px' }}>
                            <Input type="number" name="buyProductsCount" id="buyProductsCount" placeholder={i18n.t('screens:promotionTypeScreen.number')}
                                invalid={(invalidForm && !comboDeal.buyProductsCount)}
                                onChange={this.changeFieldState}
                                onKeyPress={(e) => this.negativeIntegersValidation(e)}
                                value={this.getValue(comboDeal.buyProductsCount)}
                                min={0}
                            />
                            <FormFeedback style={comboErrorMessage}>{i18n.t('common:validations.errorMsg')}</FormFeedback>
                        </Col>
                        <Label style={labelField}>{i18n.t('screens:promotionTypeScreen.buyConditionInfo')}</Label>
                        <Col sm={2}>
                            <Input type="number" name="freeProductsCount" id="freeProductsCount" placeholder={i18n.t('screens:promotionTypeScreen.number')}
                                invalid={(invalidForm && !comboDeal.freeProductsCount)}
                                onChange={this.changeFieldState}
                                onKeyPress={(e) => this.negativeIntegersValidation(e)}
                                value={this.getValue(comboDeal.freeProductsCount)}
                                min={1}
                            />
                            <FormFeedback style={comboErrorMessage}>{i18n.t('common:validations.errorMsg')}</FormFeedback>
                        </Col>
                        <Label style={labelField}>{i18n.t('screens:promotionTypeScreen.buyNumOfProductsInfo')}</Label>
                        <Col sm={2}>
                            <Input type="number" name="discountValue" id="discountValue" placeholder={i18n.t('screens:promotionTypeScreen.value')}
                                invalid={(invalidForm && !comboDeal.discountValue)}
                                onChange={this.changeFieldState}
                                onKeyPress={(e) => this.negativeIntegersValidation(e)}
                                value={this.getValue(comboDeal.discountValue)}
                                min={0}
                            />
                            <FormFeedback style={comboErrorMessage}>{i18n.t('common:validations.errorMsg')}</FormFeedback>
                        </Col>
                        <Label style={labelField}>{(comboDeal.valueInPercentage) ?
                            <p style={percentStyling}>{i18n.t('screens:promotionTypeScreen.buyEachInfo')}</p>
                            : <span>{getCurrencySymbol(this.props.restaurant.currency)} {i18n.t('screens:promotionTypeScreen.each')}</span>}
                        </Label>
                        <Col sm={12} style={{ paddingLeft: '0px' }}>
                            <Label check for='valueIsDiscount' style={{ marginRight: 45 }}>
                                {i18n.t('screens:promotionTypeScreen.valueIsDiscount')}
                                <Input style={labelInPercents} name='valueIsDiscount' type='checkbox'
                                    id='valueIsDiscount'
                                    checked={comboDeal ? comboDeal.valueIsDiscount : false}
                                    value={comboDeal ? comboDeal.valueIsDiscount : false}
                                    onChange={this.changeCheckBoxState}
                                />
                            </Label>
                            <Label check for="comboDiscountInPercentage">
                                {i18n.t('screens:promotionTypeScreen.buyValueInfo')}
                                <Input style={labelInPercents} name="valueInPercentage" type="checkbox"
                                    id="valueInPercentage"
                                    checked={comboDeal ? comboDeal.valueInPercentage : false}
                                    value={comboDeal ? comboDeal.valueInPercentage : false}
                                    onChange={this.changeCheckBoxState}
                                />
                            </Label>
                        </Col>
                    </FormGroup>
                </Form>
                <div style={infoMessagesContainer}>
                    <span style={timeFormatInfoMessage}>{i18n.t('screens:promotionTypeScreen.comboDealInfoMessage')}</span> <br />
                    <span
                        style={timeFormatInfoMessage}>{i18n.t('screens:promotionTypeScreen.comboDealSelectMessage')}</span>
                </div>
            </div>
        );
    }

    negativeIntegersValidation(e) {
        var inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 45 || inputKeyCode == 46 || inputKeyCode == 43
                || inputKeyCode == 69 || inputKeyCode == 101) {
                e.preventDefault();
            }
        }
    }
    /* Free Product Autosearch Functions */
    renderSearchResults() {
        const { searchResultContainer } = styles;

        return (
            <div style={searchResultContainer}>
                <ul className='auto-search-field'>
                    {
                        this.state.matchedFromSearch.map((result) => {
                            return <li onClick={() => this.getProductName(result.name, result.id)}>{result.name}</li>
                        })
                    }
                </ul>
            </div>
        );
    }

    handleAutoSearch() {
        if (!this.state.products.length) {
            this.props.dispatchErrorMessage(i18n.t('screens:promotionTypeScreen.noMenuConfiguredMsg'));

            return;
        }

        let searchedProduct = this.state.freeProduct.productName.toLowerCase();
        let searchStringLength = String(this.state.freeProduct.productName).length;
        // Trigger autosearch
        if (searchStringLength >= 3) {
            // filter the products for everyone that has a match with the user input
            let matchedProducts = this.state.products.filter((product) => product.name.toLowerCase().includes(searchedProduct));
            this.setState({ ...this.state, matchedFromSearch: matchedProducts });
        } else {
            let emptyMatchedFromSearchArray = this.state.matchedFromSearch.filter((product) => null);
            this.setState({ ...this.state, matchedFromSearch: emptyMatchedFromSearchArray });
        }
    }

    handleKeyUp(e) {
        this.handleAutoSearch();
        //If backspace or delete pressed trigger the autosearch
        let keyCode = e.keyCode;
        let searchedProductToString = String(this.state.freeProduct.productName);

        if (keyCode === 8 || keyCode === 46) {
            if (searchedProductToString.length >= 3) {
                this.handleAutoSearch();
            } else {
                let emptyMatchedFromSearchArray = this.state.matchedFromSearch.filter((product) => null);
                this.setState({ ...this.state, matchedFromSearch: emptyMatchedFromSearchArray });
            }
        }
    }

    handleAutoSearchFocusOut() {
        let searchedProduct = String(this.state.freeProduct.productName);

        if (searchedProduct.length < 3) {
            let emptyMatchedFromSearchArray = this.state.matchedFromSearch.filter((product) => null);
            this.setState({ ...this.state, matchedFromSearch: emptyMatchedFromSearchArray });
        } else {
            // If search string is longer than 2 characters activate the search
            this.handleAutoSearch();
        }
    }
    /* End Free Product Autosearch Functions */
    renderDescriptionField() {
        return (
            <Form inline style={{ marginBottom: 15 }}>
                <Label style={{ paddingRight: 12 }}>{i18n.t('common:form.description')}</Label>
                <Input style={{ width: '40%' }} type="text" name="description" value={this.state.description} onChange={this.changeDescriptionState} />
            </Form>
        );
    }

    render() {
        const { formContainer } = styles;

        this.copyStateFromProps();

        if (!this.props) {
            return <div></div>;
        }

        if (this.props.requestTabChange) {
            this.submitForm();
        }

        return (
            <div style={formContainer}>
                {this.renderDiscountTypeRadioBtns()}
                {this.renderDescriptionField()}

                {(!this.state.discountType) ? null : this.renderDiscountTypeContent()}
            </div>
        );
    }
};

const mapStateToProps = state => {
    return {
        products: state.restaurantProducts
    };
};

export default connect(mapStateToProps, { loadRestaurantProducts, dispatchErrorMessage })(PromotionTypeScreen);

const styles = {
    formContainer: {
        marginTop: 20,
        paddingTop: 20,
        paddingBottom: 20,
        paddingLeft: 20,
        paddingRight: 20,
        backgroundColor: '#f8f8f8',
        border: '1px solid #E9ECEF'
    },
    discountTypeRadioBtns: {
        marginLeft: 10,
        marginRight: 10
    },
    inputFieldFormGroup: {
        alignItems: 'center',
        height: 80,
        float: 'left'
    },
    inputFieldLabel: {
        alignSelf: 'center',
        paddingRight: 10,
        paddingLeft: 15,
        paddingBottom: 8
    },
    validationFieldInput: {
        width: 85,
        marginRight: 10
    },
    formGroup: {
        float: 'left',
        alignSelf: 'center',
        marginTop: 20,
        marginLeft: 40
    },
    checkboxInput: {
        position: "relative",
        marginLeft: 10
    },
    textLabelStyle: {
        float: 'left',
        alignItems: 'center',
        height: 80,
        marginLeft: 16
    },
    radioBtnStyle: {
        position: 'relative',
        top: 0,
        marginLeft: 10,
        marginRight: 10
    },
    labelField: {
        lineHeight: 3
    },
    smallFormContainer: {
        height: 75,
        paddingLeft: 15
    },
    smallFormContainerComboDeal: {
        height: 80,
        paddingLeft: 15
    },
    radioButtonsContainer: {
        marginBottom: 20
    },
    discountLabelField: {
        lineHeight: 3,
        marginLeft: 20
    },
    labelInPercents: {
        marginLeft: 15
    },
    percentStyling: {
        marginBottom: 0
    },
    infoMessagesContainer: {
        position: 'relative'
    },
    timeFormatInfoMessage: {
        fontSize: 12,
        color: '#d6d6d6',
        position: 'absolute',
        right: 0
    },
    searchResultContainer: {
        backgroundColor: '#ffffff',
        display: 'inline-block',
        width: 284,
        position: 'absolute',
        top: 46,
        left: 71,
        border: '1px solid #d2d2d2'
    },
    comboErrorMessage: {
        width: 150
    },
    formFeedback: {
        width: 150
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/promotions/PromotionTypeScreen.js